import { providerApi } from '@/api/ProviderApi'
import { useQuery } from '@tanstack/react-query'
import { closestIndexTo, format } from 'date-fns'
import { isNil } from 'ramda'
import { useMemo } from 'react'

const useFetchUpcomingVrdhCall = () => {
	const { data = null, isLoading } = useQuery({
		queryKey: ['upcoming-vrdh-calls'],
		queryFn: () => providerApi.fetchUpcomingVrdhCalls(),
		select: (data) => {
			if (!data || data.length === 0 || !data[0]) {
				return null
			}

			const upcomingVrdhCallIndex = closestIndexTo(
				Date.now(),
				data.map((call) => call.startTimeUtc)
			)

			if (isNil(upcomingVrdhCallIndex)) {
				return null
			}

			const upcomingCall = data[upcomingVrdhCallIndex]

			if (isNil(upcomingCall)) {
				return null
			}

			const startDate = format(upcomingCall.startTimeUtc, 'MMM do')
			const startTime = format(upcomingCall?.startTimeUtc, 'h:mm a')

			upcomingCall.startTimeFormatted = `${startDate} at ${startTime}`

			return upcomingCall
		},
	})

	const hasUpcomingCall = useMemo(() => data !== null, [data])

	return {
		isLoading,
		vrdhCall: data,
		hasUpcomingCall,
	}
}

export { useFetchUpcomingVrdhCall }
